import React, { useContext } from 'react';
import classNames from 'classnames';
import RoundButton from '../../../../../components/RoundButton';
import { Context } from '../../../../../context/AppContext';
import { MODALS } from '../../../../../constants';
import { QuickInfoButton } from '../QuickInfo';
import Directions from '../../../../../assets/directions.svg';
import Call from '../Call';

const Bottom = ({
  websites,
  emails,
  callNumbers,
  name,
  listingId,
  category,
  market,
  region,
  suburb,
  state,
  slogan,
  locations,
  categoryId,
  synopsis,
  recentReview,
  showQuickInfo,
  setShowQuickInfo,
}) => {
  const {
    media: { desktop },
    modal: { showModal },
  } = useContext(Context);

  const [mainLocation] = locations || [];
  const { mapPin, directions } = mainLocation || {};

  return synopsis ||
    recentReview ||
    (websites && !!websites.length) ||
    (emails && !!emails.length) ||
    (callNumbers && !!callNumbers.length) ? (
    <div
      className={classNames('Listview__Card__bottom', {
        'Listview__Card__bottom--showQuickInfo': showQuickInfo,
      })}
    >
      {(synopsis || recentReview || slogan) && (
        <QuickInfoButton
          show={showQuickInfo}
          onClick={() => setShowQuickInfo(!showQuickInfo)}
        />
      )}
      {desktop ? (
        <>
          {websites && !!websites.length && (
            <RoundButton
              size="smaller"
              theme="outlineLightGrey"
              tag="a"
              icon={<i className="icon-generalwebsite" />}
              href={websites[0].link}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="Listview__Card__button Listview__Card__button--website"
            >
              Website
            </RoundButton>
          )}
          <Call number={callNumbers} />
          {emails && !!emails.length && (
            <RoundButton
              className="Listview__Card__button Listview__Card__button--email"
              size="smaller"
              theme="outlinePurple"
              icon={<i className="icon-categorypostoffices" />}
              rel="noopener noreferrer nofollow"
              onClick={() =>
                showModal(MODALS.ENQUIRY_FORM, {
                  subTitle: name,
                  businessName: name,
                  categoryName: category,
                  listingId,
                  categoryId,
                  market,
                  region,
                  suburbName: suburb,
                  state,
                })
              }
            >
              Email
            </RoundButton>
          )}
        </>
      ) : (
        <>
          {mapPin && (
            <RoundButton
              className="Listview__Card__button Listview__Card__button--directions"
              size="smaller"
              theme="outlineLightGrey"
              tag="a"
              rel="noopener noreferrer nofollow"
              target="_blank"
              icon={<img src={Directions} alt="directions" width={18} />}
              href={directions}
              style={{
                fontSize: '14px',
              }}
            >
              Directions
            </RoundButton>
          )}
          {(!callNumbers || (callNumbers && !callNumbers.length) || !mapPin) &&
            emails &&
            !!emails.length && (
              <RoundButton
                className="Listview__Card__button Listview__Card__button--email"
                size="smaller"
                theme="outlinePurple"
                rel="noopener noreferrer nofollow"
                icon={<i className="icon-categorypostoffices" />}
                onClick={() =>
                  showModal(MODALS.ENQUIRY_FORM, {
                    subTitle: name,
                    businessName: name,
                    categoryName: category,
                    listingId,
                    categoryId,
                    market,
                    region,
                    suburbName: suburb,
                    state,
                  })
                }
                style={{
                  fontSize: '14px',
                }}
              >
                Email
              </RoundButton>
            )}
          {(!callNumbers || (callNumbers && !callNumbers.length) || !mapPin) &&
            emails &&
            !emails.length &&
            websites &&
            !!websites.length && (
              <RoundButton
                className="Listview__Card__button Listview__Card__button--email"
                size="smaller"
                theme="outlinePurple"
                icon={<i className="icon-categorypostoffices" />}
                rel="noopener noreferrer nofollow"
                onClick={() =>
                  showModal(MODALS.ENQUIRY_FORM, {
                    subTitle: name,
                    businessName: name,
                    categoryName: category,
                    listingId,
                    categoryId,
                    market,
                    region,
                    suburbName: suburb,
                    state,
                  })
                }
                style={{
                  fontSize: '14px',
                }}
              >
                Email
              </RoundButton>
            )}
          <Call
            number={callNumbers}
            style={{
              fontSize: '14px',
            }}
          />
        </>
      )}
    </div>
  ) : (
    ''
  );
};

export default Bottom;
